<era-pane>
  <div class="d-flex justify-content-between row">
    <h5 class="col-auto small-caps"
        i18n>Location</h5>
    <ml-mdm-command-spinner [commandProgress]="commandProgress$"
                            [small]="true"
                            [direction]="'right'"
                            [reverse]="true"
                            class="col text-end">
      <button [disabled]="!isLostModeEnabled()"
              type="button"
              (click)="deviceLocation()"
              [class]="'btn btn-outline-primary border-0'">
        <fa-icon icon="sync"></fa-icon>
      </button>
    </ml-mdm-command-spinner>
  </div>
  <small class="form-text text-muted"
         [hidden]="isSupervised()">Availabe when device is supervised.</small>
  <small class="form-text text-muted"
         [hidden]="hasSupportedOS()">Available in iOS 10.3 and later.</small>

  @if (isSupported) {
    <div>
      <small class="form-text text-muted mb-2"
             [hidden]="isLostModeEnabled()">Device must be in Lost Mode to enable refresh.</small>
    </div>
  }

  @if (location | async; as location) {
    <div>
      @if (isSupported) {
        <div>
          <table class="table table-sm table-list mb-2">
            <thead>
              <tr>
                <th colspan="2"
                    scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th style="width: 175px"
                    title="The latitude of the device’s current location."
                    data-toggle="tooltip"
                    data-placement="right"
                    scope="row">
                  Latitude
                </th>
                <td>{{ location.latitude }}</td>
              </tr>
              <tr>
                <th title="The longitude of the device’s current location."
                    data-toggle="tooltip"
                    data-placement="right"
                    scope="row">
                  Longitude
                </th>
                <td>{{ location.longitude }}</td>
              </tr>
              <tr>
                <th title="The radius of uncertainty for the location, measured in meters. If negative, this value could not be determined."
                    data-toggle="tooltip"
                    data-placement="right"
                    scope="row">
                  Horizontal Accuracy
                </th>
                <td>{{ location.horizontalAccuracy }}</td>
              </tr>
              <tr>
                <th title="The accuracy of the altitude value in meters. If negative, this value could not be determined."
                    data-toggle="tooltip"
                    data-placement="right"
                    scope="row">
                  Vertical Accuracy
                </th>
                <td>{{ location.verticalAccuracy }}</td>
              </tr>
              <tr>
                <th title="The altitude of the device’s current location. If negative, this value could not be determined."
                    data-toggle="tooltip"
                    data-placement="right"
                    scope="row">
                  Altitude
                </th>
                <td>{{ location.altitude }}</td>
              </tr>
              <tr>
                <th title="The instantaneous speed of the device in meters per second. If negative, this value could not be determined."
                    data-toggle="tooltip"
                    data-placement="right"
                    scope="row">
                  Speed
                </th>
                <td>{{ location.speed }}</td>
              </tr>
              <tr>
                <th title="The direction in which the device is traveling. If negative, this value could not be determined."
                    data-toggle="tooltip"
                    data-placement="right"
                    scope="row">
                  Course
                </th>
                <td>{{ location.course }}</td>
              </tr>
              <tr>
                <th title="The RFC 3339 timestamp for when this location was determined."
                    data-toggle="tooltip"
                    data-placement="right"
                    scope="row">
                  Timestamp
                </th>
                <td>{{ location.timestamp }}</td>
              </tr>
            </tbody>
          </table>
          <button type="button"
                  class="col-auto align-self-center btn btn-primary"
                  [class.disabled]="!isEnabled"
                  (click)="map(location)">
            <fa-icon icon="location-arrow"></fa-icon>
            <span i18n> View on map</span>
          </button>
        </div>
      }
    </div>
  }
</era-pane>